module.exports = __webpack_public_path__ + "static/media/TISF.ee987884.png";